import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=bacf97ac&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=bacf97ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf97ac",
  null
  
)

export default component.exports